import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { AlgoliaAnalyticsHelpers, AlgoliaAnalyticsTypes } from "@grandvisionhq/analytics";
import { withIntl, useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { getResultsByIndex } from "../../Algolia/utils/Algolia/utils/get-results-by-index.js";
import SearchSuggestion from "../../SearchSuggestion/SearchSuggestion/SearchSuggestion.js";
import { StoreSuggestion } from "../../StoreSuggestion/StoreSuggestion/StoreSuggestion.js";
import SuggestionBlock from "../../SuggestionBlock/SuggestionBlock/SuggestionBlock.js";
import ContentResultsContainer from "../components/SearchResults/components/ContentSuggestionContainer.js";
/* empty css                   */
import { ProductSuggestionContainer } from "../../ProductSuggestion/containers/ProductSuggestion/containers/ProductSuggestionContainer.js";
const SearchResults = (props) => {
  const { pageRoutes, suggestionIndex, contentIndex, storeIndex, onSubmit, productIndex } = props;
  const {
    indexUiState: { query },
    scopedResults
  } = useInstantSearch();
  const { getLabel } = useIntl();
  const { isMultilingualEnabled } = useFeatureToggles();
  const productSuggestions = getResultsByIndex(scopedResults, productIndex.name);
  const querySuggestions = suggestionIndex && getResultsByIndex(scopedResults, suggestionIndex.name);
  const storeSuggestions = storeIndex && getResultsByIndex(scopedResults, storeIndex.name);
  const contentSuggestions = contentIndex && getResultsByIndex(scopedResults, contentIndex.name);
  const isValidQuery = (query2) => {
    if (!!query2 && query2.length >= 2) {
      return true;
    }
    return false;
  };
  const validQuery = isValidQuery(query);
  const handleSubmit = (page) => {
    if (isValidQuery(query)) {
      onSubmit(query, page);
    }
  };
  const handleClickAnalytics = React.useCallback(
    (searchIndex) => (objectID, position) => {
      const currentSearchState = getResultsByIndex(scopedResults, searchIndex);
      if (currentSearchState?.queryID) {
        AlgoliaAnalyticsHelpers.clickedObjectIdsAfterSearch({
          searchIndex,
          queryId: currentSearchState.queryID,
          eventName: AlgoliaAnalyticsTypes.AlgoliaAnalyticsEvents.SearchSuggestionClicked,
          objectIds: objectID,
          positions: position
        });
      }
    },
    [scopedResults]
  );
  const getStoresPath = () => {
    const pathFromPageRoutes = pageRoutes?.stores;
    const pathFromConfig = storeIndex && storeIndex.targetPath || "";
    return pathFromPageRoutes || pathFromConfig;
  };
  return /* @__PURE__ */ React.createElement("div", { className: "search-results" }, querySuggestions && /* @__PURE__ */ React.createElement("div", { className: "search-results__suggestions search-results__query-suggestions" }, /* @__PURE__ */ React.createElement(
    SuggestionBlock,
    {
      suggestions: querySuggestions.hits,
      title: getLabel("search.suggestions.suggestions.title"),
      render: (hit) => /* @__PURE__ */ React.createElement(
        SearchSuggestion,
        {
          key: hit.objectID,
          suggestion: hit,
          targetPath: suggestionIndex && suggestionIndex.targetPath || "",
          onClick: handleClickAnalytics(querySuggestions.index)
        }
      )
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "search-results__suggestions" }, productSuggestions && validQuery && /* @__PURE__ */ React.createElement(
    SuggestionBlock,
    {
      title: getLabel("search.suggestions.products.title"),
      handleSubmit: () => handleSubmit("products"),
      suggestions: productSuggestions.hits,
      render: (hit) => /* @__PURE__ */ React.createElement(
        ProductSuggestionContainer,
        {
          key: hit.objectID,
          suggestion: hit,
          onClick: handleClickAnalytics(productSuggestions.index)
        }
      )
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "search-results__suggestions" }, storeSuggestions && validQuery && /* @__PURE__ */ React.createElement(
    SuggestionBlock,
    {
      title: getLabel("search.suggestions.stores.title"),
      handleSubmit: () => handleSubmit("stores"),
      suggestions: storeSuggestions.hits,
      render: (hit) => /* @__PURE__ */ React.createElement(
        StoreSuggestion,
        {
          isMultilingualEnabled,
          key: hit.objectID,
          suggestion: hit,
          targetPath: getStoresPath()
        }
      )
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "search-results__suggestions" }, contentSuggestions && validQuery && /* @__PURE__ */ React.createElement(
    ContentResultsContainer,
    {
      suggestions: contentSuggestions,
      handleClickAnalytics,
      handleSubmit
    }
  )));
};
const SearchResults$1 = withIntl(SearchResults);
export {
  SearchResults,
  SearchResults$1 as default
};
//# sourceMappingURL=SearchResults.js.map
